import "./IconAmwayLogo.scss";
import { ReactComponent as AmwayLogoIcon } from "./svg/icon_amway_logo.svg";

export const IconAmwayLogo = () => {
  return (
    <span className="IconAmwayLogo">
      <AmwayLogoIcon />
    </span>
  );
};
